import {
  Box,
  IconButton,
  Input as MInput,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { closeDialogue } from "../../util/Dialogue";
import Input from "../../Component/Common/Input";
import Button from "../../Component/Common/Button";
import { getCSVData } from "../../util/general-apis";
import Select from "../../Component/Common/Select";
import { bulkAddOrgUser } from "../../store/organizationUser/organizationUser.action";
import CloseIcon from "@mui/icons-material/Close";
import { isEmail, isPhone } from "../../util/textValidation";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "13px",
  border: "1px solid #C9C9C9",
  boxShadow: 24,
  p: "19px",
  minWidth: "1000px",
  minHeight: "500px",
  maxHeigth: "calc(100% - 32px)",
};

const BulkAddMembers = ({ currentTab }) => {
  const dispatch = useDispatch();
  const { dialogue } = useSelector((state) => state.dialogue);
  const { departments, roles } = useSelector((state) => state.organizationUser);
  const { orgProfile } = useSelector((state) => state.organization);

  const [uploadedData, setUploadedData] = useState([]);

  const [errors, setErrors] = useState([]);

  const closePopup = () => {
    closeDialogue(dispatch);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    console.log(departments);
    console.log(roles);

    if (file) {
      let data = await getCSVData(file);
      data = data.map((mem) => ({
        email: mem.email,
        phone: mem.phone,
        department:
          departments.find((d) => {
            return d.name?.toLowerCase() === mem.department.toLowerCase();
          })?._id || "",
        role:
          roles.find(
            (role) => role.label.toLowerCase() === mem.role.toLowerCase(),
          )?.value || "org_viewer",
      }));
      console.log("CSV Data : ", data);
      setUploadedData(data);
    }

    event.target.value = "";
  };

  const handleInputChange = (index, target) => {
    const { name, value } = target;

    setUploadedData((prev) => {
      let temp = [...prev];
      temp[index][name] = value;
      return temp;
    });
  };

  const handleRemoveRow = (index) => {
    setUploadedData((prev) => prev.filter((_, idx) => idx !== index));
  };

  const handleSubmit = () => {
    let error = [];
    // TODO : validate Data
    // if (!uploadedData.every((mem) => mem.phone || mem.email)) {
    //   setErrors({
    //     email: "Email or Phone is required",
    //   });
    //   return;
    // }
    uploadedData.forEach((mem, index) => {
      if (!mem.phone && !mem.email) {
        error[index] = {
          email: "Email or Phone is required",
          phone: "Email or Phone is required",
        };
      } else {
        const isValidEmail = isEmail(mem.email);
        const isValidPhone = isPhone(mem.phone);

        if (mem.email && !isValidEmail) {
          error[index] = {
            email: "Enter a valid email!",
          };
        }
        if (mem.phone && !isValidPhone) {
          error[index] = {
            ...(error[index] || {}),
            phone: "Enter a valid phone number!",
          };
        }
      }
    });

    if (error.length > 0) {
      setErrors(error);
      return;
    }

    console.log("ERR ", error);
    console.log(uploadedData);

    dispatch(bulkAddOrgUser(uploadedData, currentTab));

    closePopup();
  };

  return (
    <Modal
      open={dialogue}
      onClose={closePopup}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} className="create-member-model create-modal">
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Add Members
        </Typography>
        <form style={{ minHeight: "400px" }}>
          <div className="row row-gap-4">
            <div className="col-12">
              {uploadedData.length ? (
                <div className="d-flex justify-content-end gap-2">
                  <Button
                    className={"bg-primary"}
                    type="button"
                    onClick={() => setUploadedData([])}
                  >
                    Upload Again
                  </Button>
                  <Button
                    className={"submit"}
                    type="button"
                    onClick={handleSubmit}
                  >
                    Add All
                  </Button>
                </div>
              ) : (
                <Input type="file" accept=".csv" onChange={handleFileUpload} />
              )}
            </div>

            {uploadedData.length ? (
              <>
                <TableContainer component={Paper}>
                  <p
                    className="text-secondary mb-2 mt-1"
                    style={{ fontSize: 14 }}
                  >
                    Note: Phone is prioritized over Email, if both are provided
                    in .csv file.
                  </p>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell>Phone</TableCell>
                        <TableCell align="right">Department</TableCell>
                        <TableCell align="right">Role</TableCell>
                        <TableCell align="right"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {uploadedData.map((row, index) => (
                        <>
                          {errors[index] && (
                            <div className="px-3 errorMessage">
                              {errors[index].phone || errors[index].email}
                            </div>
                          )}
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              <MInput
                                name="email"
                                value={row.email}
                                fullWidth
                                type="email"
                                onChange={(event) => {
                                  handleInputChange(index, event.target);
                                  setErrors((prev) => ({
                                    ...prev,
                                    [index]: null,
                                  }));
                                }}
                                error={!!errors[index]?.email}
                              />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <MInput
                                name="phone"
                                value={row.phone}
                                fullWidth
                                type="text"
                                onChange={(event) => {
                                  handleInputChange(index, event.target);
                                  setErrors((prev) => ({
                                    ...prev,
                                    [index]: null,
                                  }));
                                }}
                                error={!!errors[index]?.phone}
                              />
                            </TableCell>
                            <TableCell align="left">
                              <Select
                                options={departments.map((d) => ({
                                  label: d.name,
                                  value: d._id,
                                }))}
                                value={row.department}
                                onValueChange={(value) =>
                                  handleInputChange(index, {
                                    name: "department",
                                    value,
                                  })
                                }
                              />
                            </TableCell>
                            <TableCell align="left">
                              <Select
                                options={roles}
                                value={row.role}
                                onValueChange={(value) =>
                                  handleInputChange(index, {
                                    name: "role",
                                    value,
                                  })
                                }
                              />
                            </TableCell>
                            <TableCell align="center">
                              <IconButton
                                onClick={() => handleRemoveRow(index)}
                              >
                                <CloseIcon style={{ marginRight: 0 }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : orgProfile.subscriptionId ? (
              <>
                <div className="px-4 py-2 text-secondary">
                  <b>Note:</b> You have{" "}
                  {orgProfile.subscriptionId.planId.limits.maxMembers -
                    orgProfile.currentUsage.membersAdded}{" "}
                  seats available in your subscription.
                </div>
                <div>
                  Click here to{" "}
                  <a href="https://caretube.blr1.digitaloceanspaces.com/CareTube/bulk-add.csv">
                    download
                  </a>{" "}
                  .csv template.
                </div>
              </>
            ) : null}
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default BulkAddMembers;
